import { Badge, Card } from "flowbite-react";
import React, { useEffect, useState } from "react";
import TitleStripe from "../../common/TitleStripe";
import NoOcurrence from "../../common/query/NoOcurrence";
import PendenciasFinanceiras from "../../common/query/PendenciasFinanceiras";
import Protestos from "../../common/query/Protestos";
import HistoricoConsultas from "../../common/query/HistoricoConsultas";
import AvisoCard from "../../common/query/AvisoCard";
import { EvaluationScore } from "../../common/query/EvaluationScore";
import ChequesSustados from "../../common/query/ChequesSustados";
import ChequesSemFundos from "../../common/query/ChequesSemFundos";
import ReactApexChart from "react-apexcharts";
import ParticipacaoEmEmpresas from "../../common/query/ParticipacaoEmEmpresas";
import AcoesCiveis from "../../common/query/AcoesCiveis";
import {
  calculateRiskScore,
  formatDocument,
  formatToReal,
  getImageURLScore,
  getImageURLScoreSerasa,
  getLetterScore,
  getScoreLegends,
} from "../../../utils/utils";
import moment from "moment";

const SerasaPremiumQuery = ({ data }) => {
  return (
    <div>
      <div className="flex items-center justify-between mb-5">
        <img className="w-40" src="/assets/logo_serasa.png" />
      </div>

      <div>
        <div
          className="font-semibold text-2xl pb-1 border-b"
          style={{ color: "#a7763c" }}
        >
          Serasa Premium
        </div>

        <div className="mt-5 flex justify-end">
          {moment().format("DD MMMM yyyy HH:mm:ss")}
        </div>

        <div className="overflow-scroll-x mt-1">
          <table className="rounded w-full border-collapse">
            <thead>
              <tr>
                <td
                  className="p-1 font-semibold text-white uppercase text-sm border-gray-300 border"
                  style={{
                    background: "#ecf1f7",
                    color: "#43679c",
                  }}
                >
                  CPF/CNPJ
                </td>
                <td
                  className="p-1 font-semibold text-white uppercase text-sm border-gray-300 border"
                  style={{
                    background: "#ecf1f7",
                    color: "#43679c",
                  }}
                >
                  Status
                </td>
                <td
                  className="p-1 font-semibold text-white uppercase text-sm border-gray-300 border"
                  style={{
                    background: "#ecf1f7",
                    color: "#43679c",
                  }}
                >
                  Banco
                </td>
                <td
                  className="p-1 font-semibold text-white uppercase text-sm border-gray-300 border"
                  style={{
                    background: "#ecf1f7",
                    color: "#43679c",
                  }}
                >
                  Agência
                </td>
                <td
                  className="p-1 font-semibold text-white uppercase text-sm border-gray-300 border"
                  style={{
                    background: "#ecf1f7",
                    color: "#43679c",
                  }}
                >
                  Conta
                </td>
                <td
                  className="p-1 font-semibold text-white uppercase text-sm border-gray-300 border"
                  style={{
                    background: "#ecf1f7",
                    color: "#43679c",
                  }}
                >
                  Cheque
                </td>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="p-2 border-gray-300 border">
                  <div>
                    {formatDocument(
                      data?.dadosCadastrais?.cpf || data?.dadosCadastrais?.cnpj
                    )}
                  </div>
                </td>
                <td className="p-2 border-gray-300 border">
                  <div>
                    {(+data?.resumoConsulta?.pendenciasFinanceiras
                      ?.quantidadeTotal || 0) +
                      (+data?.resumoConsulta?.protestos?.quantidadeTotal || 0) +
                      (+data?.resumoConsulta?.chequesSemFundo
                        ?.quantidadeTotal || 0)}{" "}
                    anotações
                  </div>
                </td>
                <td className="p-2 border-gray-300 border">
                  <div></div>
                </td>
                <td className="p-2 border-gray-300 border">
                  <div></div>
                </td>
                <td className="p-2 border-gray-300 border">
                  <div></div>
                </td>
                <td className="p-2 border-gray-300 border">
                  <div></div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div className="mt-5">
        <div
          className="font-semibold text-2xl pb-1 border-b"
          style={{ color: "#a7763c" }}
        >
          Resumo da consulta
        </div>

        <div className="overflow-scroll-x mt-4">
          <table className="rounded w-full border-collapse">
            <thead>
              <tr>
                <td
                  className="p-1 font-semibold text-white uppercase text-sm border-gray-300 border"
                  style={{
                    background: "#ecf1f7",
                    color: "#43679c",
                  }}
                >
                  CPF/CNPJ
                </td>
                <td
                  className="p-1 font-semibold text-white uppercase text-sm border-gray-300 border"
                  style={{
                    background: "#ecf1f7",
                    color: "#43679c",
                  }}
                >
                  Nome/Razão Social
                </td>
                <td
                  className="p-1 font-semibold text-white uppercase text-sm border-gray-300 border"
                  style={{
                    background: "#ecf1f7",
                    color: "#43679c",
                  }}
                >
                  {data?.dadosCadastrais?.cpf ? "Nome da mãe" : "Situação"}
                </td>
                <td
                  className="p-1 font-semibold text-white uppercase text-sm border-gray-300 border"
                  style={{
                    background: "#ecf1f7",
                    color: "#43679c",
                  }}
                >
                  {data?.dadosCadastrais?.cpf
                    ? "Data de Nascimento"
                    : "Data de Fundação"}
                </td>
              </tr>
            </thead>
            <tbody className="text-sm">
              <tr>
                <td className="p-2 border-gray-300 border">
                  <div>
                    {formatDocument(
                      data?.dadosCadastrais?.cpf || data?.dadosCadastrais?.cnpj
                    )}
                  </div>
                </td>
                <td className="p-2 border-gray-300 border">
                  <div>
                    {data?.dadosCadastrais?.nome ||
                      data?.dadosCadastrais?.razaoSocial}
                  </div>
                </td>
                <td className="p-2 border-gray-300 border">
                  <div>
                    {data?.dadosCadastrais?.nomeMae ||
                      data?.dadosCadastrais?.situacao}
                  </div>
                </td>
                <td className="p-2 border-gray-300 border">
                  <div>
                    {data?.dadosCadastrais?.dataNascimento ||
                      data?.dadosCadastrais?.dataFundacao}
                  </div>
                </td>
              </tr>
              <tr>
                <td
                  className="p-2 border-gray-300 border font-semibold"
                  style={{
                    background: "#f1f1f1",
                    color: "#7c7074",
                  }}
                >
                  <div>Ocorrências</div>
                </td>
                <td
                  className="p-2 border-gray-300 border font-semibold"
                  style={{
                    background: "#f1f1f1",
                    color: "#7c7074",
                  }}
                >
                  <div>Quantidade</div>
                </td>
                <td
                  className="p-2 border-gray-300 border font-semibold"
                  style={{
                    background: "#f1f1f1",
                    color: "#7c7074",
                  }}
                >
                  <div>Valor</div>
                </td>
                <td
                  className="p-2 border-gray-300 border font-semibold"
                  style={{
                    background: "#f1f1f1",
                    color: "#7c7074",
                  }}
                >
                  <div>Último registro</div>
                </td>
              </tr>
              <tr>
                <td className="p-2 border-gray-300 border">
                  <div>Pendências Financeiras</div>
                </td>
                <td className="p-2 border-gray-300 border uppercase ">
                  <div>
                    {+data?.resumoConsulta?.pendenciasFinanceiras
                      ?.quantidadeTotal > 0 ? (
                      data?.resumoConsulta?.pendenciasFinanceiras
                        ?.quantidadeTotal
                    ) : (
                      <span style={{ color: "#738dc5" }}>
                        Não constam ocorrências
                      </span>
                    )}
                  </div>
                </td>
                <td className="p-2 border-gray-300 border text-right">
                  <div>
                    {+data?.resumoConsulta?.pendenciasFinanceiras
                      ?.quantidadeTotal > 0 ? (
                      formatToReal(
                        data?.resumoConsulta?.pendenciasFinanceiras?.valorTotal
                      )
                    ) : (
                      <span style={{ color: "#738dc5" }}>-</span>
                    )}
                  </div>
                </td>
                <td className="p-2 border-gray-300 border text-right">
                  <div>-</div>
                </td>
              </tr>
              <tr>
                <td className="p-2 border-gray-300 border">
                  <div>Protesto Nacional</div>
                </td>
                <td className="p-2 border-gray-300 border uppercase ">
                  <div>
                    {+data?.resumoConsulta?.protestos?.quantidadeTotal > 0 ? (
                      data?.resumoConsulta?.protestos?.quantidadeTotal
                    ) : (
                      <span style={{ color: "#738dc5" }}>
                        Não constam ocorrências
                      </span>
                    )}
                  </div>
                </td>
                <td className="p-2 border-gray-300 border text-right">
                  <div>
                    {+data?.resumoConsulta?.protestos?.quantidadeTotal > 0 ? (
                      formatToReal(data?.resumoConsulta?.protestos?.valorTotal)
                    ) : (
                      <span style={{ color: "#738dc5" }}>-</span>
                    )}
                  </div>
                </td>
                <td className="p-2 border-gray-300 border text-right">
                  <div>-</div>
                </td>
              </tr>
              <tr>
                <td className="p-2 border-gray-300 border">
                  <div>Cheques Sem Fundo BACEN</div>
                </td>
                <td className="p-2 border-gray-300 border uppercase ">
                  <div>
                    <span style={{ color: "#738dc5" }}>
                      {+data?.resumoConsulta?.chequesSemFundo?.quantidadeTotal >
                      0 ? (
                        data?.resumoConsulta?.chequesSemFundo?.quantidadeTotal
                      ) : (
                        <span style={{ color: "#738dc5" }}>
                          Não constam ocorrências
                        </span>
                      )}
                    </span>
                  </div>
                </td>
                <td className="p-2 border-gray-300 border text-right">
                  <div>-</div>
                </td>
                <td className="p-2 border-gray-300 border text-right">
                  <div>-</div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div className="mt-5">
        <div
          className="font-semibold text-2xl pb-1 border-b"
          style={{ color: "#a7763c" }}
        >
          Detalhes do documento
        </div>

        <div className="flex items-center gap-2 mt-2 mb-2">
          <img src="/assets/danger.png" />
          <div className="text-sm">
            Situação do CPF/CNPJ em{" "}
            {moment(data?.situacao?.rfb?.SIT_DATE).format("DD/MM/yyyy") || "-"}
          </div>
        </div>

        <div className="border-gray-300 border">
          <div
            className="p-1 font-semibold text-white text-sm border-gray-300 border-b"
            style={{
              background: "#ecf1f7",
              color: "#43679c",
            }}
          >
            Serasa Score com Positivo
          </div>

          <div className="grid grid-cols-6 items-center gap-4 p-4">
            <div className="flex-1 mt-2 col-span-2">
              <img
                className="px-6 mx-auto min-w-60"
                src={`${getImageURLScoreSerasa(data?.score?.score || 0)}`}
              />
              <div className="flex flex-col  mx-auto text-center -mt-10">
                <span className="font-semibold text-xl">
                  {data?.score?.score}
                </span>
                <span className="text-sm text-gray-400">de 1000</span>
              </div>
            </div>
            <div
              className="flex flex-col items-center text-white p-3 rounded-md"
              style={{ background: "#5d95cb" }}
            >
              <div className="font-semibold text-2xl">
                {data?.score?.probabilidadeInadimplencia}%
              </div>
              <div className="text-sm text-center">chance de inadimplência</div>
            </div>
            <div
              className="p-2 flex-1 col-span-3 text-sm"
              style={{
                border: "solid 1px #5d95cb",
                color: "#5d95cb",
              }}
            >
              A decisão da aprovação ou não do crédito é de exclusiva
              responsabilidade do concedente. As informações prestadas pela
              Serasa Experian têm como objetivo subsidiar essas decisões e, em
              hipótese alguma, devem ser utilizadas como justificativa, pelo
              concedente do crédito, para a tomada da referida decisão
            </div>
          </div>
        </div>

        <div className="overflow-scroll-x mt-4">
          <table className="rounded w-full border-collapse">
            <thead>
              <tr>
                <td
                  className="p-1 font-semibold text-white text-sm border-gray-300 border"
                  style={{
                    background: "#ecf1f7",
                    color: "#43679c",
                  }}
                  colSpan={4}
                >
                  {data?.dadosCadastrais?.cpf
                    ? "Participação em empresas"
                    : "Quadro Societário"}
                </td>
              </tr>
            </thead>
            <tbody>
              {data?.socios?.length > 0 ? (
                data?.socios?.map((participacao, index) => (
                  <>
                    <tr>
                      <td
                        className="p-2 border-gray-300 border font-semibold"
                        style={{
                          background: "#f1f1f1",
                          color: "#7c7074",
                        }}
                      >
                        <div>
                          {data?.dadosCadastrais?.cpf ? "Empresa" : "Nome"}
                        </div>
                      </td>
                      <td
                        className="p-2 border-gray-300 border font-semibold"
                        style={{
                          background: "#f1f1f1",
                          color: "#7c7074",
                        }}
                      >
                        <div>
                          {" "}
                          {data?.dadosCadastrais?.cpf ? "CNPJ" : "CPF"}
                        </div>
                      </td>
                      <td
                        className="p-2 border-gray-300 border font-semibold"
                        style={{
                          background: "#f1f1f1",
                          color: "#7c7074",
                        }}
                      >
                        <div>Participação</div>
                      </td>
                      <td
                        className="p-2 border-gray-300 border font-semibold"
                        style={{
                          background: "#f1f1f1",
                          color: "#7c7074",
                        }}
                      >
                        <div>
                          {data?.dadosCadastrais?.cpf ? "UF" : "Restrição"}
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td className="p-2 border-gray-300 border">
                        {participacao.empresa || participacao.nome}
                      </td>
                      <td className="p-2 border-gray-300 border">
                        {formatDocument(participacao.cnpj || participacao.cpf)}
                      </td>
                      <td className="p-2 border-gray-300 border">
                        {participacao.participacaoEmPorcentagem ||
                          participacao.percentualParticipacao}
                      </td>
                      <td className="p-2 border-gray-300 border">
                        {data?.dadosCadastrais?.cpf
                          ? "-"
                          : participacao.temRestricao
                          ? "Sim"
                          : "Não"}
                      </td>
                    </tr>
                    <tr>
                      <td className="p-2 border-gray-300 border"></td>
                      <td className="p-2 border-gray-300 border">
                        <span className="font-semibold">
                          Desde: {participacao?.dataEntrada || "-"}
                        </span>
                      </td>
                      <td className="p-2 border-gray-300 border" colSpan={2}>
                        <span className="font-semibold">
                          Última Atualização: -
                        </span>
                      </td>
                    </tr>
                  </>
                ))
              ) : (
                <tr>
                  <td colSpan={4} className="p-2 border-gray-300 border">
                    ESTE {data?.dadosCadastrais?.cpf ? "CPF" : "CNPJ"} NÃO
                    POSSUI PARTICIPAÇÃO SOCIETÁRIA EM NENHUMA EMPRESA
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        <div className="overflow-scroll-x mt-4">
          <table className="rounded w-full border-collapse">
            <thead>
              <tr>
                <td
                  className="p-1 font-semibold text-white text-sm border-gray-300 border"
                  style={{
                    background: "#ecf1f7",
                    color: "#43679c",
                  }}
                >
                  Documentos Roubados, Furtados ou Extraviados
                </td>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="p-2 border-gray-300 border">
                  NAO CONSTAM OCORRENCIAS
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div className="overflow-scroll-x mt-4">
          <table className="rounded w-full border-collapse">
            <thead>
              <tr>
                <td
                  className="p-1 font-semibold text-white text-sm border-gray-300 border"
                  style={{
                    background: "#ecf1f7",
                    color: "#43679c",
                  }}
                  colSpan={8}
                >
                  Pendências Financeiras
                </td>
              </tr>
            </thead>
            <tbody>
              {data?.pendenciasFinanceiras?.length > 0 ? (
                <>
                  {" "}
                  <tr>
                    <td
                      className="p-2 border-gray-300 border font-semibold"
                      style={{
                        background: "#f1f1f1",
                        color: "#7c7074",
                      }}
                    >
                      <div>Data</div>
                    </td>
                    <td
                      className="p-2 border-gray-300 border font-semibold"
                      style={{
                        background: "#f1f1f1",
                        color: "#7c7074",
                      }}
                    >
                      <div>Tipo</div>
                    </td>
                    <td
                      className="p-2 border-gray-300 border font-semibold"
                      style={{
                        background: "#f1f1f1",
                        color: "#7c7074",
                      }}
                    >
                      <div>Empresa</div>
                    </td>
                    <td
                      className="p-2 border-gray-300 border font-semibold"
                      style={{
                        background: "#f1f1f1",
                        color: "#7c7074",
                      }}
                    >
                      <div>Valor</div>
                    </td>
                    <td
                      className="p-2 border-gray-300 border font-semibold"
                      style={{
                        background: "#f1f1f1",
                        color: "#7c7074",
                      }}
                    >
                      <div>Contrato</div>
                    </td>
                  </tr>
                  {data?.pendenciasFinanceiras?.map((serasa, index) => (
                    <tr key={index}>
                      <td className="p-2 border-gray-300 border">
                        <div>{serasa.data}</div>
                      </td>
                      <td className="p-2 border-gray-300 border">
                        <div>{serasa.tipoPendencia || "-"}</div>
                      </td>
                      <td className="p-2 border-gray-300 border">
                        <div>{serasa.informante || "-"}</div>
                      </td>
                      <td className="p-2 border-gray-300 border">
                        <div>{formatToReal(serasa?.valor || 0)}</div>
                      </td>
                      <td className="p-2 border-gray-300 border">
                        <div>{serasa?.contrato || "-"}</div>
                      </td>
                    </tr>
                  ))}
                  <tr>
                    <td
                      style={{ background: "#fffbed" }}
                      className="p-2 border-gray-300 border"
                      colSpan={8}
                    >
                      Total de ocorrências :{" "}
                      {
                        data?.resumoConsulta?.pendenciasFinanceiras
                          ?.quantidadeTotal
                      }{" "}
                      {" | "}
                      Valor total das ocorrências:{" "}
                      {formatToReal(
                        data?.resumoConsulta?.pendenciasFinanceiras?.valorTotal
                      ) || 0}
                    </td>
                  </tr>
                </>
              ) : (
                <tr>
                  <td colSpan={8} className="p-2 border-gray-300 border">
                    NAO CONSTAM OCORRENCIAS
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        <div className="overflow-scroll-x mt-4">
          <table className="rounded w-full border-collapse">
            <thead>
              <tr>
                <td
                  className="p-1 font-semibold text-white text-sm border-gray-300 border"
                  style={{
                    background: "#ecf1f7",
                    color: "#43679c",
                  }}
                  colSpan={8}
                >
                  Protesto Nacional
                </td>
              </tr>
            </thead>
            <tbody>
              {data?.protestos?.length > 0 ? (
                <>
                  <tr>
                    <td
                      className="p-2 border-gray-300 border font-semibold"
                      style={{
                        background: "#f1f1f1",
                        color: "#7c7074",
                      }}
                    >
                      <div>Data</div>
                    </td>
                    <td
                      className="p-2 border-gray-300 border font-semibold"
                      style={{
                        background: "#f1f1f1",
                        color: "#7c7074",
                      }}
                    >
                      <div>Valor</div>
                    </td>
                    <td
                      className="p-2 border-gray-300 border font-semibold"
                      style={{
                        background: "#f1f1f1",
                        color: "#7c7074",
                      }}
                    >
                      <div>Cartório</div>
                    </td>
                    <td
                      className="p-2 border-gray-300 border font-semibold"
                      style={{
                        background: "#f1f1f1",
                        color: "#7c7074",
                      }}
                    >
                      <div>Contrato</div>
                    </td>
                    <td
                      className="p-2 border-gray-300 border font-semibold"
                      style={{
                        background: "#f1f1f1",
                        color: "#7c7074",
                      }}
                    >
                      <div>Cidade</div>
                    </td>
                    <td
                      className="p-2 border-gray-300 border font-semibold"
                      style={{
                        background: "#f1f1f1",
                        color: "#7c7074",
                      }}
                    >
                      <div>UF</div>
                    </td>
                  </tr>
                  {data?.protestos.map((protesto, index) => (
                    <tr key={index}>
                      <td className="p-2 border-gray-300 border">
                        <div>{protesto.data}</div>
                      </td>
                      <td className="p-2 border-gray-300 border">
                        {formatToReal(protesto?.valor || 0)}
                      </td>
                      <td className="p-2 border-gray-300 border">
                        <div>{protesto.cartorio || "-"} cartório</div>
                      </td>
                      <td className="p-2 border-gray-300 border">-</td>
                      <td className="p-2 border-gray-300 border">
                        <div>{protesto.cidade || "-"}</div>
                      </td>
                      <td className="p-2 border-gray-300 border">
                        <div>{protesto.uf || "-"}</div>
                      </td>
                    </tr>
                  ))}
                  <tr>
                    <td
                      style={{ background: "#fffbed" }}
                      className="p-2 border-gray-300 border"
                      colSpan={8}
                    >
                      Total de ocorrências :{" "}
                      {data?.resumoConsulta?.protestos?.quantidadeTotal}
                      {" | "}
                      Valor total das ocorrências:{" "}
                      {formatToReal(
                        data?.resumoConsulta?.protestos?.valorTotal || 0
                      )}
                    </td>
                  </tr>
                </>
              ) : (
                <tr>
                  <td colSpan={8} className="p-2 border-gray-300 border">
                    NAO CONSTAM OCORRENCIAS
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        <div className="overflow-scroll-x mt-4">
          <table className="rounded w-full border-collapse">
            <thead>
              <tr>
                <td
                  className="p-1 font-semibold text-white text-sm border-gray-300 border"
                  style={{
                    background: "#ecf1f7",
                    color: "#43679c",
                  }}
                  colSpan={4}
                >
                  Cheques Sem Fundo BACEN
                </td>
              </tr>
            </thead>
            <tbody>
              {data?.chequesSemFundo?.length > 0 ? (
                <>
                  <tr>
                    <td
                      className="p-2 border-gray-300 border font-semibold"
                      style={{
                        background: "#f1f1f1",
                        color: "#7c7074",
                      }}
                    >
                      <div>Data</div>
                    </td>
                    <td
                      className="p-2 border-gray-300 border font-semibold"
                      style={{
                        background: "#f1f1f1",
                        color: "#7c7074",
                      }}
                    >
                      <div>Agência</div>
                    </td>
                    <td
                      className="p-2 border-gray-300 border font-semibold"
                      style={{
                        background: "#f1f1f1",
                        color: "#7c7074",
                      }}
                    >
                      <div>Banco</div>
                    </td>
                    <td
                      className="p-2 border-gray-300 border font-semibold"
                      style={{
                        background: "#f1f1f1",
                        color: "#7c7074",
                      }}
                    >
                      <div>Quantidade</div>
                    </td>
                  </tr>
                  {data?.chequesSemFundo.map((protesto, index) => (
                    <tr key={index}>
                      <td className="p-2 border-gray-300 border">
                        <div>{protesto.data}</div>
                      </td>
                      <td className="p-2 border-gray-300 border">
                        {protesto.agencia}
                      </td>
                      <td className="p-2 border-gray-300 border">
                        <div>{protesto.banco || "-"} cartório</div>
                      </td>
                      <td className="p-2 border-gray-300 border">
                        {protesto.quantidade}
                      </td>
                    </tr>
                  ))}
                  <tr>
                    <td
                      style={{ background: "#fffbed" }}
                      className="p-2 border-gray-300 border"
                      colSpan={8}
                    >
                      Total de ocorrências :{" "}
                      {data?.resumoConsulta?.chequesSemFundo?.quantidadeTotal}
                    </td>
                  </tr>
                </>
              ) : (
                <tr>
                  <td colSpan={8} className="p-2 border-gray-300 border">
                    NAO CONSTAM OCORRENCIAS
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        <div className="overflow-scroll-x mt-4">
          <table className="rounded w-full border-collapse">
            <thead>
              <tr>
                <td
                  className="p-1 font-semibold text-white text-sm border-gray-300 border"
                  style={{
                    background: "#ecf1f7",
                    color: "#43679c",
                  }}
                >
                  Consultas à Serasa realizadas ao mesmo documento
                </td>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="p-2 border-gray-300 border">
                  NAO CONSTAM OCORRENCIAS
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div
        className="border border-gray-200 p-2 mt-4"
        style={{ background: "#fffbed" }}
      >
        Simples consulta ao {data?.dadosCadastrais?.cpf ? "CPF" : "CNPJ"} (
        {formatDocument(
          data?.dadosCadastrais?.cpf || data?.dadosCadastrais?.cnpj
        )}
        ) no cadastro da Serasa. Essa informação de consulta não significa
        negócio realizado, nem se confunde com anotação negativa no cadastro de
        inadimplentes.
      </div>

      <div className="border border-gray-200 p-2 flex items-center gap-1 font-semibold mt-2">
        <span
          style={{
            color: "#43679c",
          }}
        >
          PROTOCOLO DA CONSULTA:
        </span>
        <span style={{ color: "#b8243c" }}>
          {" "}
          {Math.floor(100000 + Math.random() * 900000)}
        </span>
      </div>

      <div className="mt-4">
        A decisão da aprovação ou não do crédito é de exclusiva responsabilidade
        do concedente. As informações prestadas pela Serasa Experian têm como
        objetivo subsidiar essas decisões e, em hipótese alguma, devem ser
        utilizadas como justificativa, pelo concedente do crédito, para a tomada
        da referida decisão.
      </div>
    </div>
  );
};

export default SerasaPremiumQuery;
